// Vuex user module main file
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  faqsForUser: [],
};

const getters = {
  faqsForUser: state => state.faqsForUser,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  actions,
  mutations,
  getters,
};

export default Module;
